<template>
    <div
        class="rounded-md border p-4 w-full h-44 flex flex-col items-center justify-center"
        :class="availableCredits ? ' bg-branding-green-light border-branding-green-border' : 'bg-branding-disable'"
    >
        <div
            class="rounded-full flex justify-center items-center size-11 mb-4"
            :class="availableCredits ? 'bg-branding-green text-branding-white' : ' bg-branding-simple-grey'"
        >
            <i class="fa-regular fa-coins text-xl"></i>
        </div>
        <div
            class="font-semibold text-center"
            :class="availableCredits ? 'text-branding-green' : 'text-branding-active-grey'"
        >
            {{ $t('settings.credit.basket', { count: availableCredits }) }}
        </div>
    </div>
</template>

<script lang="ts" setup>
    defineProps<{
        availableCredits: number;
    }>();
</script>
